import { render } from "./ArchChooser.vue?vue&type=template&id=2cbf7467&scoped=true"
import script from "./ArchChooser.vue?vue&type=script&lang=js"
export * from "./ArchChooser.vue?vue&type=script&lang=js"

import "./ArchChooser.vue?vue&type=style&index=0&id=2cbf7467&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cbf7467"]])

export default __exports__